import { useTranslation } from "react-i18next";
import { Draw } from "@mui/icons-material";
import CommonModal from "@components/common/Modal/Modal";
import Button from "@components/common/Button/Button";

export interface SignatureRequiredModalProps {
	isOpen: boolean;
	onOpenProfile: () => void;
}

/**
 * Blocking prompt when the signed-in user has no profile signature.
 * Rendered from ModalManager; visibility is driven by Redux + MainLayout sync.
 */
const SignatureRequiredModal: React.FC<SignatureRequiredModalProps> = ({ isOpen, onOpenProfile }) => {
	const { t } = useTranslation();

	return (
		<CommonModal
			isOpen={isOpen}
			onClose={() => undefined}
			showCloseIcon={false}
			width="max-w-md"
			rounded="rounded-2xl"
			padding="p-6"
			footer={
				<div className="flex justify-center border-t border-slate-200/90 pt-4">
					<Button onClick={onOpenProfile} variant="primary">
						{t("psdaCommon.profile.signatureRequired.openProfile")}
					</Button>
				</div>
			}>
			<div className="flex flex-col items-center text-center">
				<div className="w-32 h-32 bg-green-100 rounded-full flex items-center justify-center mb-4">
					<Draw sx={{ fontSize: 48 }} className="w-24 h-24 text-green-600" />
				</div>
				<h2 className="text-xl font-semibold text-gray-900 mb-2">
					{t("psdaCommon.profile.signatureRequired.title")}
				</h2>
				<p className="text-sm text-gray-600">{t("psdaCommon.profile.signatureRequired.message")}</p>
			</div>
		</CommonModal>
	);
};

export default SignatureRequiredModal;
